import React from 'react'
import classNames from 'classnames'

import { Icon } from '@scentregroup/ui'

import { User } from '../../../../types/user'
import { incBaseIdentity } from '../../../helpers/paths'

import style from './index.module.scss'
import Nav from '.'

const Account: React.FC<{
  from?: string
  redirect?: string
  user?: User
  onClose: () => void
}> = ({ from = '', redirect, user, onClose }) => {
  const path =
    redirect || `${location.pathname}${location.search}${location.hash}`

  // eslint-disable-next-line compat/compat
  const searchParams = new URLSearchParams({ path })

  if (from !== '') {
    searchParams.append('from', from)
  }

  const loginUrl = `${incBaseIdentity('login')}?${searchParams.toString()}`
  const signupUrl = `${incBaseIdentity('register')}?${searchParams.toString()}`
  const logoutUrl = `${incBaseIdentity('logout')}?${searchParams.toString()}`

  const items = user
    ? [
        () => (
          <div
            className={classNames(style.item, style['item-big'])}
            data-test-id="main-navdrawer-welcome-message"
          >
            {user.firstName ? `Hi, ${user.firstName}!` : 'Hi!'}
          </div>
        ),
        { label: 'Account', url: incBaseIdentity(`account-info`) },
        { label: 'Orders', url: incBaseIdentity(`account-info/orders`) },
        {
          label: 'Payment methods',
          url: incBaseIdentity(`account-info/payment-methods`),
        },
        () => <hr />,
        { label: 'Sign out', url: logoutUrl },
      ]
    : [
        {
          label: 'Login',
          url: loginUrl,
          className: classNames(style['item-big']),
        },
        {
          label: 'Sign up',
          url: signupUrl,
          className: classNames(style['item-big']),
        },
        {
          label: 'About Westfield Plus',
          url: '/westfield-plus',
          attrs: {
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        () => (
          <>
            <div className={classNames(style.item, style.title)}>
              Members get more
            </div>
            <div className={classNames(style.item)}>
              <Icon
                size="small"
                type="tick"
                className={classNames(style.icon)}
              />
              <span>Free delivery options</span>
            </div>
            <div className={classNames(style.item)}>
              <Icon
                size="small"
                type="tick"
                className={classNames(style.icon)}
              />
              <span>10% back on Click &amp; Collect</span>
            </div>
            <div className={classNames(style.item)}>
              <Icon
                size="small"
                type="tick"
                className={classNames(style.icon)}
              />
              <span>Easy returns</span>
            </div>
          </>
        ),
      ]

  return (
    <Nav
      className={classNames(style['nav-reverse'])}
      items={items}
      onClose={onClose}
    />
  )
}

export default Account
